import i18n from './index';

export const t = (key, options) => i18n.t(key, options);

export const appointmentStatusLabel = (status) =>
  t(`status.appointment.${status}`, { defaultValue: status?.replace(/_/g, ' ') });

export const orderStatusLabel = (status) =>
  t(`status.order.${status}`, { defaultValue: status?.replace(/_/g, ' ') });

export const orderStepLabel = (status) =>
  t(`status.orderStep.${status}`, { defaultValue: status?.replace(/_/g, ' ') });

export const assignmentStatusLabel = (status) =>
  t(`status.appointmentAssignment.${status}`, { defaultValue: status?.replace(/_/g, ' ') });

export const campaignStatusLabel = (status) =>
  t(`status.campaign.${status}`, { defaultValue: status });

export const tenantStatusLabel = (status) =>
  t(`status.tenant.${status}`, { defaultValue: status });

export const stockBadgeLabel = (badge) =>
  t(`status.stock.${badge}`, { defaultValue: badge });

export const activityActionLabel = (action) =>
  t(`activity.${action}`, { defaultValue: action?.replace(/_/g, ' ').toLowerCase() });

export const describeActivity = (log) => {
  if (log.description) return log.description;
  const base = activityActionLabel(log.action);
  const meta = log.metadata || {};
  if (meta.rejectionReason) return t('activity.withReason', { action: base, reason: meta.rejectionReason });
  if (meta.reason) return t('activity.withReason', { action: base, reason: meta.reason });
  return base;
};

export const localeDate = (date, options) =>
  new Date(date).toLocaleDateString(i18n.language === 'si' ? 'si-LK' : i18n.language === 'ta' ? 'ta-LK' : 'en-GB', options);

export const localeDateTime = (date) =>
  new Date(date).toLocaleString(i18n.language === 'si' ? 'si-LK' : i18n.language === 'ta' ? 'ta-LK' : 'en-GB');
